// removed by extract-text-webpack-plugin
module.exports = {"popover_trigger":"_3YrEtFz1_T6o4gWcI10KQU","popover_body":"_25tcjY4B7dgEHiMIMbTbNM","top_right":"TNo-G6WsJ4Q-wKCo_Qags","top_left":"_3eIYWck-7oZOQb6a269tuL","bottom_right":"_1whAtu3sCOwpPa-GLKPOV_","bottom_left":"a9Bfj_qj_QT8Q5q_8mDvb","popover_mask":"_1GCbGYa9ieOGIutBq5eoLf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Popover/Popover.css
// module id = 538
// module chunks = 0